import { SectionsTreeNode } from '../types';

export const getTreeNodeKeyByPageId = (bundleSections: SectionsTreeNode[], pageId: string): string | null => {
  const findNode = (nodes: SectionsTreeNode[]): string | null => {
    for (const node of nodes) {
      if (node.pageIds && node.pageIds.includes(pageId)) {
        return node.id;
      }
      if (node.children) {
        const childId = findNode(node.children);
        if (childId) {
          return childId;
        }
      }
    }
    return null;
  };

  return findNode(bundleSections);
};
